import React, { useCallback, useContext, useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import PopNotificationsContext from 'providers/PopNotifications/PopNotifications.context';
import { AxiosError } from 'axios';
import { ERROR_TYPES, ERRORS_USER_FRIENDLY } from 'request-responses';
import { getAxiosErrorMessageCode } from 'axiosUtils';

export default function useErrors() {
  const { popError } = useContext(PopNotificationsContext);

  const { t } = useTranslation();

  const RenderInvalidTypeContent = useMemo(
    () => (
      <div className="pop-info-custom-content">
        <p className="title">{t('invalidTypeTitle')}</p>
        <p className="description">{t('invalidTypeDescirption')}</p>
      </div>
    ),
    [t],
  );

  const popUploadError = useCallback(
    ({ code, message }: { code: string; message: string }) => {
      const isInvalidType = code === 'file-invalid-type' || code === '125';

      popError(isInvalidType ? RenderInvalidTypeContent : message);
    },
    [RenderInvalidTypeContent, popError],
  );

  const popCustomUploadError = useCallback(
    (e: AxiosError) => {
      const errorCode = getAxiosErrorMessageCode(e);

      const error = {
        code: String(errorCode),
        message: t(
          ERRORS_USER_FRIENDLY[errorCode] ||
            ERRORS_USER_FRIENDLY[ERROR_TYPES.COULDNT_PARSE],
        ),
      };

      popUploadError(error);
    },
    [popUploadError, t],
  );

  return { popCustomUploadError };
}
